module.exports = __webpack_public_path__ + "static/media/tours.7dde468a.jpg";